import {
  Interface,
  type
} from 'implement-js'
import {
  RetailItemCommChild
} from './retailItemCommChild'

export const RetailItemCommChildList = Interface('RetailItemCommChildList')({
  RetailItemCommChild: type('array', [type('object', RetailItemCommChild)])
}, {
    // when true, errors and warnings are triggered when properties
    // other than those on the Interface are found, is suppressed if
    // trim is set to true - default: false
    strict: true,

    // remove methods that don’t match the Interface - default: false
    trim: true,

    // throws an error when Interface isn’t implemented - default: false
    error: false,

    // warns when Interface isn’t implemented - default: true
    warn: false
})
